<template>
  <touch-relation-part v-if="visible && env.touch" :part="part" :data="data" :readonly="readonly" :viewmode="viewmode"></touch-relation-part>
  <mouse-relation-part v-else-if="visible" :part="part" :data="data" :readonly="readonly" :viewmode="viewmode"></mouse-relation-part>
</template>

<script setup lang="ts">
import {type PartProps, partProps} from "../../Part";
import useEditor from "../Editor";
import {injectEnv} from "../../Environment";
import TouchRelationPart from "./TouchRelationPart.vue";
import MouseRelationPart from "./MouseRelationPart.vue";

const uprops = defineProps({ ...partProps });
const props = uprops as PartProps;

const { visible, value, clazz, style, ro } = useEditor(props);
const env = injectEnv();
</script>

<style>
</style>
